module.exports = __webpack_public_path__ + "img/giorgio-armani.1fc7957d.jpg";